import clsx from 'clsx';
import type { Ref } from 'react';

import * as styles from './list.css';
import type { ColWrapperProps } from './types';

export function ColWrapper({
  ref,
  flex,
  alignment,
  hideInSmallContainer,
  hidden,
  className,
  style,
  children,
  ...rest
}: ColWrapperProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      {...rest}
      ref={ref}
      data-testid="page-list-flex-wrapper"
      style={{
        ...style,
        flexGrow: flex,
        flexBasis: flex ? `${(flex / 12) * 100}%` : 'auto',
        justifyContent: alignment,
      }}
      data-hide-item={hideInSmallContainer ? true : undefined}
      className={clsx(className, styles.colWrapper, {
        [styles.hidden]: hidden,
        [styles.hideInSmallContainer]: hideInSmallContainer,
      })}
    >
      {children}
    </div>
  );
}

export const withinDaysAgo = (date: Date, days: number): boolean => {
  const startDate = new Date();
  const day = startDate.getDate();
  const month = startDate.getMonth();
  const year = startDate.getFullYear();
  return new Date(year, month, day - days + 1) <= date;
};

export const betweenDaysAgo = (
  date: Date,
  days0: number,
  days1: number
): boolean => {
  return !withinDaysAgo(date, days0) && withinDaysAgo(date, days1);
};

export function shallowEqual(objA: unknown, objB: unknown) {
  if (Object.is(objA, objB)) {
    return true;
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  const recordA = objA as Record<string, unknown>;
  const recordB = objB as Record<string, unknown>;

  const keysA = Object.keys(recordA);
  const keysB = Object.keys(recordB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (
      !Object.prototype.hasOwnProperty.call(recordB, key) ||
      !Object.is(recordA[key], recordB[key])
    ) {
      return false;
    }
  }

  return true;
}
